import { Link, Outlet } from "react-router-dom";
import Header from "../controls/Header";
import { useEffect, useState,  } from "react";
import Menu from "../controls/Menu";
import { useSelector,useDispatch } from "react-redux";
import AxiosAPI from "../../api/AxiosAPI";
import MobileMenu from "../controls/MobileMenu";
import { setAcl } from "../../redux/slices/aclSlice";
import { fetchRegistration } from "../../api/RegistrationApi";
import { isMobileView } from "../controls/CommonFunctions";

const Layout = () => {
  const [showMenu, setShowMenu] = useState(true);
  const [isDrawerOpen,setIsDrawerOpen]=useState(false);
  const [registrationData, setRegistrationData] = useState(null);
  const user = useSelector((state) => state.user.user);
  const store = useSelector((state) => state.store.store);
  const dispatch = useDispatch();

  const fetchAcl = async () => {
    try {
      const res = await AxiosAPI.get(`/user/access?storeid=${store?.key}`);
      console.log(res, "acl response ");
      const aclModules = res.data.modules;
      dispatch(setAcl(aclModules)); // Update Redux

    } catch (err) {
      console.log(err, "while fetching the acl");
    }
  };

  

  const fetchRegisterationDetails = async () => {
    try {
      // await salesDB.openDB();
      // const cachedData = await salesDB.getAllData("registeration");
      // if (cachedData?.length > 0) {
      //   setRegistrationData(cachedData[0]);
      //   return;
      // }
      let registrationResponse = await fetchRegistration({
        regID: user.RegistrationID,
      });
      let registration = null;
      if (registrationResponse.code === "0") {
        registration = registrationResponse.registration;
        registration.key = user.RegistrationID;
        setRegistrationData(registration);

      }
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    if (user.RegistrationID) {
      fetchRegisterationDetails();
    }
  }, [user.RegistrationID]);

  // useEffect(() => {
  //   if (store) {
  //     fetchAcl();
  //   }
  // }, [store]);
const onMenuClick=(object)=>{
   if(object?.isDrawerOpen){
    setIsDrawerOpen(true);
   }
   else{
    setIsDrawerOpen(false);
   }
}

  return (
    <div className={`${isMobileView() ? "h-full overflow-y-auto" : "h-screen overflow-hidden"} flex w-full  bg-white`}>
      {!isMobileView() && <Menu onMenuClick={(object)=>{onMenuClick(object)}} registaerationData={registrationData} />}

      {/* Content Area */}
      <main className="w-full bg-white overflow-x-auto">
        <Outlet />
      </main>
    </div>
  );
};

export default Layout;